const formFields = [
    {
        name: 'name',
        label: trans('general.page.space_forms.model.name'),
        type: 'text',
        required: false,
        wrapClass: 'col-12 mb-2',
    },
    {
        name: 'form_preset_id',
        label: trans('general.page.space_forms.model.form'),
        type: 'select',
        placeholder: trans('general.page.space_forms.choose_form_type'),
        required: true,
        options: () => {
            return spaceFormDefinition(false)
        },
        relation: 'preset',
        wrapClass: 'col-12 mb-2',
    },
    {
        name: 'description',
        label: trans('general.page.space_forms.model.description'),
        type: 'textarea',
        placeholder: trans('general.page.space_forms.model.description'),
        required: false,
        wrapClass: 'col-12 mb-2',
    },
];

export const translatePresets = (preset) => {
    const key = 'general.page.space_forms.presets.types.' + preset;
    const translation = trans(key);

    return (translation === key) ? preset : translation;
}

export const spaceFormDefinition = async (all) => {
    const params = all ? { all: true } : {};
    const { data } = await axios.get('/space/forms/presets', { params });
    return data.data.map(({ form, id }) => ({ label: translatePresets(form), value: id }));
};

export default formFields;
